import { css } from '@emotion/react';

export const tagChipVariantStyles = {
  default: css`
    background-color: var(--surface-page);
    border: 1px solid var(--border-primary);
    color: var(--text-primary);
  `,
  active: css`
    background-color: var(--text-primary);
    border: 1px solid var(--border-secondary);
    color: var(--color-base-white);
  `,
  primary: css`
    background-color: var(--surface-disabled);
    border: 1px solid var(--surface-disabled);
    color: var(--text-primary);
  `,
  error: css`
    background-color: var(--surface-error);
    border: 1px solid var(--border-error);
    color: var(--text-error);
  `,
  success: css`
    background-color: var(--surface-success);
    border: 1px solid var(--border-success);
    color: var(--text-primary);
  `,
  warning: css`
    background-color: var(--surface-subtle);
    border: 1px solid var(--border-warning);
    color: var(--text-primary);
  `,
};
